/** Hand-drawn 1.75px stroke icons, one family, no emoji. */
const P = { fill: 'none', stroke: 'currentColor', strokeWidth: 1.75, strokeLinecap: 'round', strokeLinejoin: 'round' } as const;

export const IconPlay = () => (
  <svg viewBox="0 0 24 24" {...P} aria-hidden="true">
    <path d="M8 5.5v13l11-6.5z" fill="currentColor" stroke="none" />
  </svg>
);
export const IconPhoto = () => (
  <svg viewBox="0 0 24 24" {...P} aria-hidden="true">
    <rect x="3.5" y="5.5" width="17" height="13" rx="2.5" />
    <circle cx="9" cy="10" r="1.6" />
    <path d="M20 15l-4.5-4-6 6" />
  </svg>
);
export const IconArrow = () => (
  <svg viewBox="0 0 24 24" {...P} aria-hidden="true">
    <path d="M5 12h13M13 6l6 6-6 6" />
  </svg>
);
export const IconPost = () => (
  <svg viewBox="0 0 24 24" {...P} aria-hidden="true">
    <path d="M21 4L3 11l7 2 2 7z" />
    <path d="M10 13l11-9" />
  </svg>
);
export const IconSummary = () => (
  <svg viewBox="0 0 24 24" {...P} aria-hidden="true">
    <path d="M6 3.5h9l4 4v13H6z" />
    <path d="M15 3.5v4h4M9 12h6M9 16h6" />
  </svg>
);
export const IconBroadcast = () => (
  <svg viewBox="0 0 24 24" {...P} aria-hidden="true">
    <circle cx="12" cy="12" r="2.5" />
    <path d="M7.5 7.5a6.5 6.5 0 000 9M16.5 7.5a6.5 6.5 0 010 9M4.5 4.5a10.5 10.5 0 000 15M19.5 4.5a10.5 10.5 0 010 15" />
  </svg>
);
export const IconAudio = () => (
  <svg viewBox="0 0 24 24" {...P} aria-hidden="true">
    <path d="M4 10v4h3l5 4V6l-5 4z" />
    <path d="M16 9a4 4 0 010 6M18.5 6.5a7.5 7.5 0 010 11" />
  </svg>
);
export const IconExternal = () => (
  <svg viewBox="0 0 24 24" {...P} aria-hidden="true">
    <path d="M14 5h5v5M19 5l-8 8M18 14v5H5V6h5" />
  </svg>
);
export const IconCheck = () => (
  <svg viewBox="0 0 24 24" {...P} aria-hidden="true">
    <path d="M5 12.5l4.5 4.5L19 7.5" />
  </svg>
);
export const IconTelegram = () => (
  <svg viewBox="0 0 24 24" {...P} aria-hidden="true">
    <path d="M21 4.5L3.5 11.2c-.8.3-.8 1.2 0 1.5l4.4 1.4 1.7 5.2c.2.7 1 .9 1.5.4l2.4-2.3 4.6 3.4c.6.4 1.4.1 1.6-.6L21 4.5z" />
  </svg>
);
export const IconBack = () => (
  <svg viewBox="0 0 24 24" {...P} aria-hidden="true">
    <path d="M19 12H6M11 6l-6 6 6 6" />
  </svg>
);
export const IconClose = () => (
  <svg viewBox="0 0 24 24" {...P} aria-hidden="true">
    <path d="M6 6l12 12M18 6L6 18" />
  </svg>
);
export const IconChevron = () => (
  <svg viewBox="0 0 24 24" {...P} aria-hidden="true">
    <path d="M9 6l6 6-6 6" />
  </svg>
);
export const IconLessons = () => (
  <svg viewBox="0 0 24 24" {...P} aria-hidden="true">
    <circle cx="12" cy="12" r="8.5" />
    <path d="M10.2 8.8v6.4l5-3.2z" />
  </svg>
);
export const IconPath = () => (
  <svg viewBox="0 0 24 24" {...P} aria-hidden="true">
    <path d="M5 19v-5M10 19v-9M15 19v-7M20 19V5" />
  </svg>
);
export const IconCard = () => (
  <svg viewBox="0 0 24 24" {...P} aria-hidden="true">
    <rect x="3.5" y="6" width="17" height="12" rx="1.5" />
    <path d="M3.5 10h17M7 14.5h4" />
  </svg>
);
